export const MESSAGES_CONSTANTS = {
  DELETE_AN_ITEM: 'Delete an item',
  DELETE_ITEMS: 'Delete items',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ITEM: 'Are you sure you want to delete this item?',
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THESE_ITEMS: 'Are you sure you want to delete these items?',
  ITEM_SUCCESSFULLY_DELETED: 'Item successfully deleted.',
  ITEMS_SUCCESSFULLY_DELETED: 'Items successfully deleted.',
  ITEM_SUCCESSFULLY_SAVED: 'Item successfully saved.',
  UNEXPECTED_ERROR: 'Unexpected error occurred. Please try again later.',
}
